import React from 'react';
import Icon from '../../../components/AppIcon';

const CostOptimizationPanel = ({ recommendations }) => {
  const getImpactColor = (impact) => {
    if (impact === 'high') return 'text-success';
    if (impact === 'medium') return 'text-warning';
    return 'text-muted-foreground';
  };

  const getImpactBadge = (impact) => {
    if (impact === 'high') return 'bg-success/20 text-success';
    if (impact === 'medium') return 'bg-warning/20 text-warning';
    return 'bg-muted text-muted-foreground';
  };

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg md:text-xl font-semibold text-foreground mb-1">
            Cost Optimization Recommendations
          </h3>
          <p className="caption text-muted-foreground">
            AI-powered insights for margin improvement
          </p>
        </div>
        <Icon name="Lightbulb" size={20} className="text-accent" />
      </div>
      <div className="space-y-4">
        {recommendations?.map((rec) => (
          <div 
            key={rec?.id}
            className="p-4 rounded-lg border border-border hover:border-primary/50 transition-smooth cursor-pointer"
          >
            <div className="flex items-start justify-between mb-3">
              <div className="flex items-start gap-3 flex-1">
                <div 
                  className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0"
                  style={{ backgroundColor: `${rec?.color}20` }}
                >
                  <Icon name={rec?.icon} size={20} color={rec?.color} />
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="text-sm font-semibold text-foreground mb-1">
                    {rec?.title}
                  </h4>
                  <p className="caption text-muted-foreground mb-2">
                    {rec?.description}
                  </p>
                  <div className="flex flex-wrap items-center gap-2">
                    <span className={`inline-flex items-center px-2 py-1 rounded text-xs font-semibold ${getImpactBadge(rec?.impact)}`}>
                      {rec?.impact?.toUpperCase()} IMPACT
                    </span>
                    <span className="caption text-muted-foreground">
                      Est. savings: <span className="text-success font-semibold">${rec?.savings?.toLocaleString()}/mo</span>
                    </span>
                  </div>
                </div>
              </div>
              <Icon name="ChevronRight" size={16} className="text-muted-foreground flex-shrink-0 mt-1" />
            </div>

            <div className="flex items-center gap-4 pt-3 border-t border-border">
              <div className="flex items-center gap-2">
                <Icon name="Clock" size={14} className="text-muted-foreground" />
                <span className="caption text-muted-foreground">
                  Implementation: {rec?.timeframe}
                </span>
              </div>
              <div className="flex items-center gap-2">
                <Icon name="Target" size={14} className="text-muted-foreground" />
                <span className="caption text-muted-foreground">
                  Effort: {rec?.effort}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CostOptimizationPanel;